import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","PrivacyPolicyDataId"] */ "/codebuild/output/src4290575114/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
